import { render, staticRenderFns } from "./simples.vue?vue&type=template&id=00c7931e&scoped=true&"
import script from "./simples.vue?vue&type=script&lang=js&"
export * from "./simples.vue?vue&type=script&lang=js&"
import style0 from "./simples.vue?vue&type=style&index=0&id=00c7931e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c7931e",
  null
  
)

export default component.exports